function toggleDebug()
{
    if(jQuery('#debugtitle-a').html() == 'inklappen')
    {
        jQuery('#debugtitle-a').html('uitklappen');
        jQuery.cookie("debug", "false", {path:'/'});
    }
    else
    {
        jQuery('#debugtitle-a').html('inklappen');
        jQuery.cookie("debug", null, {path:'/'});
    }
      
    jQuery('.debugerrors').toggle();
    return false;
}

function toggleDebugOpties()
{
    if(jQuery('#debugtitle-a').html() == 'opties')
    {
        jQuery('#debugtitle-a').html('foutmeldingen');
        jQuery.cookie("debug-opties", "false", {path:'/'});
    }
    else
    {
        jQuery('#debugtitle-b').html('opties');
        jQuery.cookie("debug-opties", null, {path:'/'});
    }
      
    jQuery('.debugerrors').toggle();
    return false;
}

jQuery(function(){
    if(jQuery.cookie("debug"))
    {
        if(jQuery.cookie("debug") == "false")
        {
            jQuery('.debugerrors').hide(); 
            jQuery('#debugtitle-a').html('uitklappen');
        }
    }
});